// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../../graphql/api/index';

import { ComponentTitleAmpersandFragmentDoc } from './componentTitleAmpersand.fragment.generated';
import { ComponentTitleTextFragmentDoc } from './componentTitleText.fragment.generated';
export const ComponentTitleComponentFragmentDoc = `
    fragment componentTitleComponent on ComponentTitleComponent {
  ... on ComponentTitleAmpersand {
    ...componentTitleAmpersand
  }
  ... on ComponentTitleText {
    ...componentTitleText
  }
}
    `;